export enum MerchantCategory {
    NonProfit,
    SocialWelfare,
}
